import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';
import { SignaturePreviewGuard } from '../auth/signature-preview.guard';
import { MainCanvasComponent } from './main-canvas/main-canvas.component';
import { MeSignatureComponent } from './me/me-signature/me-signature.component';
import { MeAttributesComponent } from './me/me-attributes/me-attributes.component';

const coreRoutes: Routes = [
  {
    path: '',
    component: MainCanvasComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'me-signature',
        component: MeSignatureComponent,
        canActivate: [SignaturePreviewGuard],
      },
      {
        path: 'me-attributes',
        component: MeAttributesComponent,
      },
      {
        path: '',
        redirectTo: 'me-signature',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(coreRoutes)],
  exports: [RouterModule],
})
export class CoreRoutingModule {}
